import React from 'react';
import { Homepage } from './pages/Homepage';
export function App() {
  return <Homepage data-id="element-0" />;
}